const MOBILE_BREAKPOINT = 850;

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

class CountrySelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.selector = this.querySelector("select");
    this.selector.addEventListener("change", this.changeCountry.bind(this));
  }

  changeCountry = () => {
    this.form.submit();
  };
}

customElements.define("country-selector", CountrySelector);

// Custom Element: SmartSlider
class SmartSlider extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.querySelector(".swiper-config").textContent);
    if (this.dataset.paginationNumber == "true") {
      this.config.pagination.renderBullet = function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      };
    }
    // console.log(this.config);
    this.swiper = new Swiper(this, this.config);
  }
}
customElements.define("smart-slider", SmartSlider);

class ImageScrollAnimation extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector(".inner-container");
    this.content = this.querySelector(".content-wrapper");
  }
}

customElements.define("image-scroll-animation", ImageScrollAnimation);

class FaqSingle extends HTMLElement {
  constructor() {
    super();
    this.question = this.querySelector(".faq-question");
    this.answer = this.querySelector(".faq-answer");
    this.question.addEventListener("click", this.toggleFaq.bind(this));
  }
  toggleFaq = () => {
    this.toggleAttribute("open");
    if (!this.closest('.faq-container') && !this.closest('.press-auteur')) document.body.classList.toggle("overlay-open", this.hasAttribute("open"));

    if (this.hasAttribute("open")) {
      this.answer.style.height =
        this.querySelector(".inner-ans").scrollHeight + "px";
    } else {
      this.answer.style.height = 0 + "px";
    }
  };
}

customElements.define("faq-single", FaqSingle);

class MenuOpener extends HTMLElement {
  constructor() {
    super();
    this.querySelector("h3").addEventListener("click", this.toogle.bind(this));
  }

  toogle = () => {
    this.toggleAttribute("open");

    if (this.hasAttribute("open")) {
      this.querySelector(".outer-container").style.height =
        this.querySelector(".outer-container").scrollHeight + "px";
    } else {
      this.querySelector(".outer-container").style.height = 0 + "px";
    }
  };
}

customElements.define("menu-opener", MenuOpener);

function lockBodyScroll() {
  if (isMenuOpen) return; // Already locked

  const scrollPosition = window.scrollY;
  document.body.setAttribute("data-scroll", scrollPosition);
  isMenuOpen = true;
  
  // Add data attribute to signal menu is open
  document.body.setAttribute('data-menu-open', 'true');
  
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = '100%';
  document.body.style.left = '0';

  console.log("global locked", scrollPosition);
}

function unlockBodyScroll() {
  if (!isMenuOpen) return; // Already unlocked
  
  isMenuOpen = false;
  document.body.removeAttribute("data-menu-open");
  
  const scrollPosition = parseInt(document.body.getAttribute('data-scroll'));
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('width');
  document.body.style.removeProperty('left');
  
  // Restore scroll position instantly
  window.scrollTo({
    top: scrollPosition,
    left: 0,
    behavior: 'instant'
  });

  console.log("global unlocked", scrollPosition);
}

function updateBodyLock() {
  const anyOpen = document.querySelector("option-toggler[open]");
  if (anyOpen) {
    lockBodyScroll();
  } else {
    unlockBodyScroll();
  }
}

class OptionToggler extends HTMLElement {
  constructor() {
    super();

    // Cache elements
    this.titleEl = this.querySelector(".option-title");
    this.outerEl = this.querySelector(".outer-area");
    this.selectedEl = this.querySelector(".selected_value");

    if (this.titleEl) {
      this.titleEl.addEventListener("click", this.toggleOpen);
    }

    this.querySelectorAll("input, label").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });

    this.addEventListener("change", this.changeTitle);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.querySelectorAll('button[type="submit"], .apply-button').forEach(
      (btn) => {
        btn.addEventListener("click", (e) => {
          e.stopPropagation(); // don't let the toggler's click handler run
          const form = this.closest("form");
          if (form) form.requestSubmit(); // triggers the form's submit listener
        });
      }
    );
  }

  toggleOpen = () => {
    this.toggleAttribute("open");

    if (this.hasAttribute("open")) {
      if (this.outerEl)
        this.outerEl.style.height = this.outerEl.scrollHeight + "px";
      setTimeout(() => {
        document.addEventListener("click", this.handleClickOutside);
      }, 0);
    } else {
      if (this.outerEl) this.outerEl.style.height = "0px";
      document.removeEventListener("click", this.handleClickOutside);
    }
    updateBodyLock();
  };

  handleClickOutside(event) {
    if (!this.contains(event.target) && this.hasAttribute("open")) {
      this.removeAttribute("open");
      if (this.outerEl) this.outerEl.style.height = "0px";

      updateBodyLock();
      document.removeEventListener("click", this.handleClickOutside);
    }
  }

  changeTitle = () => {
    if (!this.selectedEl) return;

    // Radios: single selection
    const radioChecked = this.querySelector('input[type="radio"]:checked');
    if (radioChecked) {
      const label = radioChecked.nextElementSibling;
      this.selectedEl.textContent = label ? label.textContent.trim() : "";
      return;
    }

    // Checkboxes: join multiple
    const checks = Array.from(
      this.querySelectorAll('input[type="checkbox"]:checked')
    )
      .map((i) => i.nextElementSibling?.textContent?.trim())
      .filter(Boolean);

    this.selectedEl.textContent = checks.join(", ");
  };

  disconnectedCallback() {
    document.removeEventListener("click", this.handleClickOutside);
  }
}

customElements.define("option-toggler", OptionToggler);

class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.video = this.querySelector("video");
    if (this.button)
      this.button.addEventListener("click", this.toggleVideo.bind(this));
    if (this.video)
      this.video.addEventListener("ended", this.onVidoEnded.bind(this));
  }

  onVidoEnded = () => {
    this.button.classList.remove("playing");
    this.removeAttribute("playing");
  };

  toggleVideo = () => {
    this.button.classList.toggle("playing");
    this.toggleAttribute("playing");
    if (this.hasAttribute("playing")) {
      this.video.play();
    } else {
      this.video.pause();
    }
  };
}

customElements.define("video-section", VideoSection);

class MegaMenuMobile extends HTMLElement {
  constructor() {
    super();
    this.titleElement = this.querySelector(".top-areas");
    this.contentElement = this.querySelector(".outer-container-links");
    //this.contentElementBox = this.querySelector('.outer-container-links .inner-container-links');
    this.titleElement.addEventListener("click", this.toggleMenu.bind(this));
  }

  toggleMenu = () => {
    this.toggleAttribute("open");
    if (this.hasAttribute("open")) {
      this.contentElement.style.height =
        this.contentElement.scrollHeight + "px";
    } else {
      this.contentElement.style.height = 0 + "px";
    }
  };
}

customElements.define("mega-menu-mobile", MegaMenuMobile);

//Overlay
document
  .querySelector(".overlay-custom")
  .addEventListener("click", function () {
    document.querySelector("cart-drawer").closeDrawer();
    document.querySelectorAll(".menu-details").forEach(function (menu) {
      menu.removeAttribute("open");
    });
  });

document.querySelectorAll(".tabs-container .tab").forEach(function (tab) {
  tab.addEventListener("click", function () {
    this.parentElement.querySelector(".active").classList.remove("active");
    this.classList.add("active");
    var tabname = this.getAttribute("data-target");
    document
      .querySelectorAll(".tabs-details .tab-detail")
      .forEach(function (td) {
        td.classList.remove("active");
        if (td.getAttribute("tabname") == tabname) {
          td.classList.add("active");
        }
      });
  });
});

document.querySelectorAll(".support-search input").forEach(function (input) {
  input.addEventListener("keyup", function () {
    var text = this.value.toLowerCase().trim();
    var length = text.length;
    if (length == 0) {
      document.querySelector(".search_results").style.display = "none";
      document.querySelectorAll(".faq-question").forEach(function (faq) {
        faq.parentElement.style.display = "block";
      });

      document.querySelector(".tabs-container").style.display = "flex";
    } else {
      document.querySelector(".search_results").style.display = "block";
      document.querySelector("[data-target='faq']").click();

      var count = 0;
      document.querySelectorAll(".faq-question").forEach(function (faq) {
        var faqtext = faq.textContent.toLowerCase();
        if (faqtext.includes(text)) {
          faq.parentElement.style.display = "block";
          count++;
        } else {
          faq.parentElement.style.display = "none";
        }
      });

      if (count == 0) {
        document.querySelector(".tabs-container").style.display = "flex";
        document.querySelectorAll(".faq-question").forEach(function (faq) {
          faq.parentElement.style.display = "block";
        });
      } else {
        document.querySelector(".tabs-container").style.display = "none";
      }

      document.querySelector(".search_results .counts").textContent = count;
      document.querySelector(".search_results .searchreesult").textContent =
        text;
    }
  });
});

let loadMoreBtn = document.getElementById("load-more");

if (loadMoreBtn) {
  loadMoreBtn.addEventListener("click", function () {
    let nextPageUrl = loadMoreBtn.getAttribute("data-next-page");

    if (nextPageUrl) {
      fetch(nextPageUrl)
        .then((response) => response.text())
        .then((data) => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, "text/html");

          // Extract new blog posts
          let newPosts = doc.querySelectorAll(".articles-grid .article-grid");
          let blogContainer = document.querySelector(".articles-grid");

          newPosts.forEach((post) => {
            blogContainer.appendChild(post);
          });

          // Update next page URL
          let nextButton = doc.getElementById("load-more");
          if (nextButton) {
            loadMoreBtn.setAttribute(
              "data-next-page",
              nextButton.getAttribute("data-next-page")
            );
          } else {
            loadMoreBtn.style.display = "none"; // Hide button if no more pages
          }

          if (
            document
              .getElementById("load-more")
              .getAttribute("data-next-page") == ""
          ) {
            document.getElementById("load-more").parentElement.style.display =
              "none";
          }
        })
        .catch((error) => console.error("Error loading more posts:", error));
    }
  });
}

document.querySelectorAll(".clinical-studies-3").forEach(function (btn) {
  btn.addEventListener("click", function () {
    this.classList.toggle("active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".terms-condition-left h5 span")
    .forEach(function (span) {
      span.addEventListener("click", function (e) {
        e.preventDefault();
        this.closest(".terms-condition-left").classList.toggle("active");
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".terms-condition-left ul li");

  // Get sections by their data-id attribute
  const sections = Array.from(listItems).map((li) => {
    let targetSelector = li.getAttribute("data-id"); // Example: "agreement-to-terms"

    if (targetSelector) {
      // Ensure it has `#` for querySelector
      if (!targetSelector.startsWith("#")) {
        targetSelector = `#${targetSelector}`;
      }
      const targetElement = document.querySelector(targetSelector);
      
      return { element: li, target: targetElement };
    }

    return { element: li, target: null };
  });

  // Scroll event listener to track sections
  window.addEventListener("scroll", function () {
    let scrollPosition = window.scrollY + 150; // Offset for better detection

    sections.forEach((section) => {
      if (section.target) {
        let sectionTop = section.target.offsetTop;
        let sectionHeight = section.target.offsetHeight;

        // Check if section is in view
        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          listItems.forEach((item) => item.classList.remove("active"));
          section.element.classList.add("active");
        }
      }
    });
  });

  // Handle click to scroll smoothly
  listItems.forEach((li) => {
    li.addEventListener("click", function (e) {
      e.preventDefault();

      document
        .querySelector(".terms-condition-left")
        .classList.remove("active");

      listItems.forEach((item) => item.classList.remove("active"));
      this.classList.add("active");

      let dataId = this.getAttribute("data-id");
      let targetSection = document.querySelector(`#${dataId}`); // Ensure it uses an ID selector
      let offset =
        window.innerWidth > 767
          ? targetSection.offsetTop - 50
          : targetSection.offsetTop - 120;

      if (targetSection) {
        window.scrollTo({
          top: offset,
          behavior: "smooth",
        });
      }
    });
  });
});

document.querySelectorAll("faq-single").forEach(function (item) {
  item.querySelectorAll(".faq-answer-popup-close").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      item.removeAttribute("open");
      document.body.classList.toggle("overlay-open", this.hasAttribute("open"));
    });
  });
});

/*document.addEventListener("DOMContentLoaded", function () {
  // First click handler
  document.addEventListener("click", function (e) {
    const listItem = e.target.closest(".our-luxury-partners-left li");

    if (listItem) {
      e.preventDefault();
      const dataId = listItem.getAttribute("data-id");

      // Remove 'active' from all list items
      document
        .querySelectorAll(".our-luxury-partners-left li")
        .forEach(function (el) {
          el.classList.remove("active");
        });

      // Add 'active' to the clicked one
      listItem.classList.add("active");

      // Remove 'active' from all content parts
      document
        .querySelectorAll(".our-luxury-partners-part")
        .forEach(function (el) {
          el.classList.remove("active");
        });

      // Add 'active' to the targeted content part
      const target = document.getElementById(dataId);
      if (target) {
        target.classList.add("active");
      }

      const firstItem = document.querySelector(
        ".our-luxury-partners-part.active .our-luxury-partners-desc-left ul li:first-child"
      );
      if (firstItem) {
        firstItem.click();
      }
    }
  });

  /* document.addEventListener("click", function (e) {
    const listItem = e.target.closest(".our-luxury-partners-desc-left li");
    if (listItem) {
      e.preventDefault();
      const dataId = listItem.getAttribute("data-id");

      // Remove 'active' from all list items
      document
        .querySelectorAll(".our-luxury-partners-desc-left li")
        .forEach(function (el) {
          el.classList.remove("active");
        });

      // Add 'active' to the clicked item
      listItem.classList.add("active");

      // Remove 'active' from address and image sections
      document
        .querySelectorAll(
          ".our-luxury-partners-address, .our-luxury-partners-img"
        )
        .forEach(function (el) {
          el.classList.remove("active");
        });

      // Activate the target elements
      const target1 = document.getElementById(dataId);
      const target2 = document.getElementById("wc-" + dataId);

      if (target1) {
        target1.classList.add("active");
      }

      if (target2) {
        target2.classList.add("active");
      }
    }
  });*/
//   document.querySelectorAll('.box-container').forEach((box) => {
//   box.addEventListener('click', function (e) {
//     e.preventDefault();
//     document.querySelectorAll('.box-container').forEach((el) =>
//       el.classList.remove('active')
//     );
//     this.classList.add('active');
//   });
// });

//   document.querySelectorAll('.box-container').forEach((box) => {
//   box.addEventListener('click', function (e) {
//     e.preventDefault();

//     // Remove 'active' class from all box-containers
//     document.querySelectorAll('.box-container').forEach((el) =>
//       el.classList.remove('active')
//     );

//     document.querySelectorAll('.box-container').forEach((el) =>
//       el.classList.remove('wc-active')
//     );
//     this.classList.add('active');

//     // Remove classes from .wc-transfrom-area-0
//     document.querySelectorAll('.wc-transfrom-area-0').forEach((el) => {
//       el.classList.remove('active', 'wc-active');
//     });

//     document.querySelectorAll('.wc-transfrom-area-3').forEach((el) => {
//       el.classList.remove('active', 'wc-active');
//     });

//     // Handle logic for .wc-transfrom-area-1
//     const area1 = document.querySelector('.wc-transfrom-area-1');
//     const area2 = document.querySelector('.wc-transfrom-area-2');
//     const area3 = document.querySelector('.wc-transfrom-area-3');
//     area3?.classList.remove('main-wc-active');

//     if (area1?.classList.contains('active')) {
//       area2?.classList.remove('wc-active');
//       area3?.classList.remove('wc-active');
//     }

//     if (area2?.classList.contains('active')) {
//       area1?.classList.add('wc-active');
//       area2?.classList.add('wc-active');
//       area3?.classList.remove('wc-active');
//     }

//     if (area3?.classList.contains('active')) {
//       area1?.classList.add('wc-active');
//       area2?.classList.add('wc-active');
//       area3?.classList.remove('wc-active');
//     }

//     if (this.classList.contains('wc-transfrom-area-3')) {
//   area1?.classList.add('wc-active');
//       area2?.classList.add('wc-active');
//       area3?.classList.add('main-wc-active');
// }

//   });
// });

document.querySelectorAll(".box-container").forEach(function (box) {
  box.addEventListener("click", function (e) {
    e.preventDefault();

    if (this.classList.contains("active")) {
      this.classList.remove("active");
    } else {
      document.querySelectorAll(".box-container").forEach(function (b) {
        b.classList.remove("active");
      });
      this.classList.add("active");
    }
  });
});

// Function to update cart visibility based on item count
function updateCartBoxVisibility(itemCount) {
  const cartCountBox = document.querySelector(".cart_count_latest_box");
  if (!cartCountBox) return;

  if (itemCount > 0) {
    cartCountBox.style.display = "block"; // Show it
  } else {
    cartCountBox.style.display = "none"; // Hide it
  }
}

// Function to update wishlist bubble visibility
function updateWishlistBubble() {
  var wishlistBubble = document.querySelector(".wishlist-count-bubble");
  var wishlistText = wishlistBubble?.querySelector("span");

  if (wishlistText) {
    if (wishlistText.textContent.trim() === "0") {
      wishlistBubble.style.display = "none";
    } else {
      wishlistBubble.style.display = "block";
    }
  }
}

// Function to fetch and update cart count
function fetchAndUpdateCartCount() {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      updateCartBoxVisibility(data.item_count);
      return data;
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

// Event-driven cart updates from pub/sub system
if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function(cartUpdateData) {
    // Update cart UI immediately when cart is updated via pub/sub
    if (cartUpdateData && cartUpdateData.cartData) {
      const itemCount = cartUpdateData.cartData.item_count;
      updateCartBoxVisibility(itemCount);
    } else {
      // Fallback: fetch cart data if not provided
      fetchAndUpdateCartCount();
    }
  });
}

// Initial load and periodic fallback polling (reduced from 3s to 30s)
document.addEventListener('DOMContentLoaded', function() {
  updateWishlistBubble();
  fetchAndUpdateCartCount();

  // Fallback polling every 30 seconds in case pub/sub updates are missed
  setInterval(function () {
    updateWishlistBubble();
    fetchAndUpdateCartCount();
  }, 30000);
});

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".swiper-container");

  sliders.forEach((sliderEl) => {
    const configEl = sliderEl.querySelector(".swiper-config");
    if (!configEl) return;

    const config = JSON.parse(configEl.textContent);

    config.loop = false; // make sure loop is off

    config.navigation.nextEl = sliderEl.querySelector(config.navigation.nextEl);
    config.navigation.prevEl = sliderEl.querySelector(config.navigation.prevEl);
    config.pagination.el = sliderEl.querySelector(config.pagination.el);
    if (config.scrollbar?.el) {
      config.scrollbar.el = sliderEl.querySelector(config.scrollbar.el);
    }

    config.pagination.clickable = true;
    config.pagination.renderBullet = function (index, className) {
      return (
        '<span class="' +
        className +
        '" data-id="' +
        index +
        '">' +
        (index + 1) +
        "</span>"
      );
    };

    const swiper = new Swiper(sliderEl, config);

    // Arrow dimming logic
    const updateArrowState = () => {
      if (config.navigation.prevEl) {
        config.navigation.prevEl.classList.toggle(
          "disabled",
          swiper.isBeginning
        );
      }
      if (config.navigation.nextEl) {
        config.navigation.nextEl.classList.toggle("disabled", swiper.isEnd);
      }
    };

    swiper.on("init", updateArrowState);
    swiper.on("slideChange", updateArrowState);
    swiper.init();
  });
});

setTimeout(function () {
  const wishlistItems = document.querySelectorAll(
    ".wish-wishlist #product-grid li"
  );
  const wishlistContainer = document.querySelector(".wish-wishlist");

  if (wishlistContainer) {
    if (wishlistItems.length > 0) {
      wishlistContainer.classList.remove("active");
    } else {
      wishlistContainer.classList.add("active");
    }
  }
}, 2000);

document.addEventListener("click", function (event) {
  const button = event.target.closest(".wishlist-btn");
  if (button) {
    setTimeout(function () {
      const wishlistItems = document.querySelectorAll(
        ".wish-wishlist #product-grid li"
      );
      const wishlistContainer = document.querySelector(".wish-wishlist");

      if (wishlistContainer) {
        if (wishlistItems.length > 0) {
          wishlistContainer.classList.remove("active");
        } else {
          wishlistContainer.classList.add("active");
        }
      }
    }, 2000);
  }
});
//});

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(
    ".link-with-icon .link-item-with-icon"
  );
  links.forEach(function (link) {
    link.addEventListener("click", function () {
      links.forEach(function (l) {
        l.classList.remove("active");
      });
      this.classList.add("active");
    });
  });
});

const currentPath = window.location.pathname;
const menuItems = document.querySelectorAll(
  ".link-with-icon .link-item-with-icon a"
);

menuItems.forEach(function (item) {
  if (item.pathname === currentPath) {
    item.classList.add("active");
  }
});

setTimeout(function () {
  var window_url = window.location.href.split("#");
  var tabId = window_url[1] ? window_url[1].replace(/^#/, "") : null;

  if (tabId) {
    const targetTab = document.querySelector(
      `.tabs-container div[data-target="${tabId}"]`
    );
    if (targetTab) {
      targetTab.click();
    }
  }
}, 1000);

document
  .querySelectorAll(".inner-menu-container .link-1-container li")
  .forEach(function (li) {
    li.addEventListener("click", function (e) {
      setTimeout(function () {
        var window_url = window.location.href.split("#");
        var tabId = window_url[1] ? window_url[1].replace(/^#/, "") : null;
        console.log("tabId:", tabId);

        if (tabId) {
          const targetTab = document.querySelector(
            `.tabs-container div[data-target="${tabId}"]`
          );
          if (targetTab) {
            targetTab.click();
          }
        }
      }, 300);
    });
  });

const journalSearch = document.querySelector(".journal-search input");
if (journalSearch) {
  journalSearch.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      const searchIcon = document.querySelector(".journal-search svg");
      if (searchIcon) {
        searchIcon.dispatchEvent(new Event("click", { bubbles: true }));
      }
    }
  });
}

let scrollPosition = 0;
let isMenuOpen = false;

function handleDrawerState() {
  const drawer = document.querySelector('.menu-drawer');
  
  if (drawer && drawer.hasAttribute('open')) {
    lockBodyScroll();
  } else {
    unlockBodyScroll();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Watch for drawer state changes
  const drawer = document.querySelector('.menu-drawer');
  const toggleButton = document.querySelector('.navigation-toggler button');
  
  if (drawer) {
    // Use MutationObserver to watch for drawer state changes
    const observer = new MutationObserver(() => {
      // Small delay to ensure the attribute change has been processed
      setTimeout(handleDrawerState, 0);
    });
    observer.observe(drawer, { 
      attributes: true, 
      attributeFilter: ['open'] 
    });
  }
  
  // Also listen for button clicks as backup
  if (toggleButton) {
    toggleButton.addEventListener("click", () => {
      setTimeout(handleDrawerState, 10);
    });
  }
});

// Adjust tracker text margin based on progress-bar__section-money height
function adjustProgressBarMargin() {
  const moneySections = document.querySelectorAll('.cart-drawer__block .progress-bar__section-money');
  const trackerText = document.querySelector('.cart-drawer__block .tracker-text');

  if (!trackerText) return;

  const hasWrapText = Array.from(moneySections).some(section => section.offsetHeight > 18);
  trackerText.style.marginTop = hasWrapText ? '18px' : '';
}

// Initialize on load and window resize
document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('resize', adjustProgressBarMargin);
  setTimeout(adjustProgressBarMargin, 500);
});
  